import SetIsActive from '@/common/components/SetIsActive'
import useMutationUpdateLuckyWheel from '@/modules/promotion/api/hooks/useMutateUpdateLuckyWheel'
import { useQueryClient } from '@tanstack/react-query'
import { LuckyWheelQueryKeys } from '@/modules/promotion/keys'
import { GetLuckyWheelResponse } from '@/modules/promotion/type'

interface ShowImageOnWheelLuckyWheelProps {
	wheelData: GetLuckyWheelResponse
	onUpdate?: (showImageOnWheel: boolean) => void
}

export function ShowImageOnWheelLuckyWheel({
	wheelData,
	onUpdate,
}: ShowImageOnWheelLuckyWheelProps) {
	const queryClient = useQueryClient()
	const { mutateAsync: updateLuckyWheel } = useMutationUpdateLuckyWheel()

	const handleMutate = async (value: boolean) => {
		await updateLuckyWheel({
			payload: {
				showImageOnWheel: value,
			},
		})

		// Call the optional callback to update parent component
		onUpdate?.(value)

		// Invalidate the lucky wheel query to refresh the data
		queryClient.invalidateQueries({
			queryKey: [LuckyWheelQueryKeys.GetLuckyWheel],
		})
	}

	return (
		<div className="flex items-center gap-3">
			<span className="text-sm font-medium">แสดงรูปภาพบนกงล้อ</span>
			<SetIsActive
				defaultChecked={wheelData.showImageOnWheel ?? false}
				onMutate={handleMutate}
				errorMessage="ไม่สามารถอัพเดทการแสดงรูปภาพได้"
			/>
		</div>
	)
}
